import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'

import useCampaignComparable from '@hooks/useCampaignComparable'

import type { CampaignComparableModel } from '@models/types'

import BrowseComparableIcon from '../../assets/browse_category.svg'

interface SearchComparablesProps {
  campaignComparable: CampaignComparableModel,
}

const BrowseComparable = (props: SearchComparablesProps) => {
  const { campaignComparable } = props

  const {
    callbacks: {
      browseCampaignComparables,
    },
  } = useCampaignComparable(campaignComparable)

  return (
    <ListItem
      borderColor="lineColor"
      boxProps={{
        borderBottom: '1px solid',
        alignItems: 'center',
        border: '1px solid',
        borderRadius: 5,
        marginTop: 'large',
        padding: 'large',
      }}
      onClick={() => browseCampaignComparables()}
      showAngleIcon
    >
      <Image backgroundSize="contain" url={BrowseComparableIcon} width={40} height={40} />

      <Box flexDirection="column" marginLeft="large">
        <Text>Browse a Category</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">Browse through recent properties</Text>
      </Box>
    </ListItem>
  )
}

export default BrowseComparable
